// eslint-disable-next-line import/prefer-default-export
export const groupBy = (arr, criteria) => arr.reduce((obj, item) => {
  // Check if the criteria is a function to run on the item or a property of it
  const key = typeof criteria === 'function' ? criteria(item) : item[criteria];

  // If the key doesn't exist yet, create it
  if (!(key in obj)) {
    // eslint-disable-next-line no-param-reassign
    obj[key] = [];
  }

  // Push the value to the object
  obj[key].push(item);

  // Return the object to the next item in the loop
  return obj;
}, {});
